'use client';

import React, { useRef } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import LeftArrow from '@/assets/icons/common/left-arrow.svg';
import RightArrow from '@/assets/icons/common/right-arrow.svg';

const LatestNews = ({ newsData }: any) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 335;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="absolute z-50 flex w-full items-center justify-center bg-white">
      {/* eslint-disable-next-line tailwindcss/enforces-negative-arbitrary-values */}
      <div className="!relative !z-20 mx-auto -mt-20 w-full px-4 lg:-mt-[84px] lg:w-[85%] lg:max-w-[73rem] lg:px-0 2xl:w-4/5">
        <p className="mb-2 text-center font-inter text-sm font-bold text-white lg:text-base">
          CollegeHai Latest Updates and Notifications
        </p>
        <div className="relative flex items-center">
          {/* Left Button */}
          <button
            onClick={() => scroll('left')}
            className="z-10 mr-2 hidden rounded-full bg-white p-2 shadow-md sm:block"
          >
            <Image className="size-14" src={LeftArrow} alt="left-arrow" />
          </button>

          {/* Scrollable Chips */}
          <div ref={scrollRef} className="hide-scrollbar flex space-x-2 overflow-x-auto py-2">
            {newsData?.results?.map((news: any, index: number) => {
              return (
                <div key={news.id} className="flex h-full min-w-[300px] items-start gap-x-2 rounded-lg border bg-white">
                  <Image
                    className="h-16 min-h-16 w-24 min-w-24 rounded-l-lg object-fill object-center lg:w-32 lg:min-w-32"
                    src={news?.featured_image?.url}
                    alt={news?.name ?? 'news-image'}
                    width={128}
                    height={128}
                    loading={index < 3 ? 'eager' : 'lazy'}
                    priority={index < 3}
                  />
                  <div className="flex h-16 flex-col justify-between py-1">
                    <Link
                      href={`/news/${news?.url}`}
                      className="line-clamp-2 pr-1 font-sans text-xs font-medium leading-4"
                    >
                      {news?.name}
                    </Link>
                    <p className="font-sans text-xs text-gray-500">{new Date(news?.updatedAt).toDateString()}</p>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Right Button */}
          <button
            onClick={() => scroll('right')}
            className="z-10 ml-2 hidden rounded-full bg-white p-2 shadow-md sm:block"
          >
            <Image className="size-14" src={RightArrow} alt="right-arrow" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default LatestNews;
